/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckLiquidCommand } from '../../models/check-liquid-command';
import { SuccessApiResponse } from '../../models/success-api-response';

export interface CheckLiquidAsync$Plain$Params {
  command?: CheckLiquidCommand;
}

export function checkLiquidAsync$Plain(http: HttpClient, rootUrl: string, params?: CheckLiquidAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, checkLiquidAsync$Plain.PATH, 'get');
  if (params) {
    rb.query('command', params.command, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

checkLiquidAsync$Plain.PATH = '/api/health-check/liquid';
